import { render, staticRenderFns } from "./BuilderAnnotation.vue?vue&type=template&id=128e0839&scoped=true&"
import script from "./BuilderAnnotation.vue?vue&type=script&lang=js&"
export * from "./BuilderAnnotation.vue?vue&type=script&lang=js&"
import style0 from "./BuilderAnnotation.vue?vue&type=style&index=0&id=128e0839&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "128e0839",
  null
  
)

export default component.exports